import { useAtomValue } from 'jotai';

import { JobExplorerMap } from './job-explorer-map/job-explorer-map';
import { ListHeadTitle } from './job-explorer-content';
import JobExplorerSidebar from './job-explorer-sidebar';
import { hasMapViewAtom } from './job-explorer-list.atoms';

export const MobileDrawerElement = ({ ambassadorCode }: { ambassadorCode?: string }) => {
  const hasMapView = useAtomValue(hasMapViewAtom);

  return (
    <div className="lg:hidden h-full bg-neutral-10" id="mobile-drawer-element">
      {hasMapView ? (
        <div data-cy="explorer-map-with-list" className="flex flex-col gap-4 lg:h-full">
          <JobExplorerMap testId="job-explorer-map-mobile" key="map-with-list" isDesktop={false} />
        </div>
      ) : (
        <div className="flex flex-col gap-4 px-4">
          <ListHeadTitle />
          <JobExplorerSidebar ambassadorCode={ambassadorCode} testId="explorer-sidebar-mobile" />
        </div>
      )}
    </div>
  );
};

export default MobileDrawerElement;
